import React from "react";
import { Tooltip } from "antd";
import Wand from "@app/assets/icons/wand";
import Modal from "./modal";

import chatStore from "../../state/store/ai-chat";

import "./style/icon.scoped.scss";

const Icon = ({ container }) => {
    const onClick = () => {
        chatStore.toggle();
    };

    return (
        <>
            <Tooltip title="CAPTIS Copilot Chat" placement="bottom">
                <div className="icon" onClick={onClick}>
                    <Wand />
                </div>
            </Tooltip>
            <Modal container={container} />
        </>
    );
};

export default Icon;
